import { Avatar } from '@mui/material';
import * as api from "api/Core";
import { ReactAutoComplete, ReactAutoCompleteProps } from 'components/AutoComplete';
import { GroupSuggestionDto } from 'models/ApiModels';
import * as React from 'react';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps extends Omit<ReactAutoCompleteProps, "selectedItems" | "onGetSuggestions" | "onChange"> {
    selectedItems?: GroupSuggestionDto[];
    onChange: (data: GroupSuggestionDto[]) => void;
}

type Props = IProps;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default class GroupAutoComplete extends React.Component<Props, IState> {

    private apiGetData = api.getGroupSuggestions();

    ///
    static defaultProps: Partial<IProps> = {
        autoFocus: false,
        readonly: false,
    };

    ///
    private getSuggestions(searchText: string, skipRecords: number, takeRecords: number): Promise<GroupSuggestionDto[]> {
        const inputValue = searchText.trim().toLowerCase();
        return this.apiGetData.execute({ searchText: inputValue, offset: skipRecords, take: takeRecords });
    }

    ///
    private handleUpdate = (items: GroupSuggestionDto[]) => {
        this.props.onChange(items);
    };

    ///
    private handleResolveAvatar(item: AutoCompleteDataModel) {
        return item.thumbnailUrl ? <Avatar src={item.thumbnailUrl} /> : null;
    }

    ///
    public render() {
        const { selectedItems } = this.props;
        return (
            <ReactAutoComplete
                {...this.props}
                selectedItems={selectedItems}
                onGetSuggestions={(searchText, skipRecords, takeRecords) => this.getSuggestions(searchText, skipRecords, takeRecords)}
                onChange={this.handleUpdate}
                onResolveAvatar={(item) => this.handleResolveAvatar(item)}
            />
        );
    }
}